<template>
  <div class="top-wrap">
    <!-- 推荐大咖 -->
    <router-link tag="div" class="item" v-for="item in data" :key="item.id" :to="'/daka/'+item.id">
      <div class="img-wrap">
        <img v-lazy="item.icon">
      </div>
      <div class="right-info">
        <router-link tag="div" class="name" :to="'/daka/'+item.id">
          <span v-html="item.name"></span>
          <label>{{item.level_desc}} {{item.level}}</label>
        </router-link>
        <div class="detail" v-html="item.honor"></div>
        <div class="remark">
          <i class="iconfont icon-weibiaoti4"></i>
          <span class="num">{{item.browses}}</span>
          <!-- <i class="iconfont icon-dianzan"></i>
          <span class="zan">{{item.goods}}</span> -->
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default: null
    }
  },
  created() {
  },
  methods: {
  }
}
</script>

<style scoped lang="stylus" ref="stylesheet/stylus">
  @import "~common/stylus/variable"
  .item
    display table
    table-layout fixed
    width 100%
    margin-top size(40)
    >div
      display table-cell
      vertical-align middle
  .img-wrap
    width size(180)
    height size(180)
    img
      width 100%
      height: 100%
      border-radius size(8)
  .right-info
    vertical-align top!important
    padding-left size(30)
    .name
      line-height size(54)
      margin-bottom size(8)
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      >span
        font-size size(30)
        font-weight 800
        color #333
      >label
        font-size size(28)
        color $color-theme
    .detail
      height size(80)
      line-height size(80/2)
      font-size size(24)
      color $color-text-l
      overflow : hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    .remark
      color $color-text-l
      padding-top size(12)
      font-size size(20)
      .iconfont
        font-size 14px
      .icon-weibiaoti4
        position relative
        top size(2)
      .icon-dianzan
        font-size 13px
      .num
        display inline-block
        min-width size(64)
        vertical-align middle
      .zan
        display inline-block
        vertical-align middle
</style>



// WEBPACK FOOTER //
// src/components/daka/card-dk.vue